import React from 'react'
import './OurCustomers.scss'
import OrangeButton from '../Components/OrangeButton'
import LogoBrick from './LogoBrick'
import HivioLogo from '../Images/hivio-logo.svg'
import TcoLogo from '../Images/tco-logo.svg'
import SchLogo from '../Images/scharmach-logo.svg'
import SesvanLogo from '../Images/sesvan-logo.svg'
import HardRockLogo from '../Images/hardrock-logo.svg'
import HavenLogo from '../Images/heven-logo.svg'
import HiltonLogo from '../Images/hilton-logo.svg'
import SheratonLogo from '../Images/sheraton-logo.svg'
import JaguarLogo from '../Images/jaguar-logo.svg'

const OurCustomers = () => {
    const handleBtnClick = () => {
        const contactPopup = document.querySelector('.contact-popup');
        if (contactPopup) {
          if (contactPopup.classList.contains('contact-popup-active')) {
            contactPopup.classList.remove('contact-popup-active');
          }
          else {
            contactPopup.classList.add('contact-popup-active');
          }
        }
      };
    return (
        <div className='our-customers full-width'>
            <div className='content main-grid'>
                <div className='our-customers-left'>
                    <h2 className='unbounded-font'>Intuitive designs that attract customers
                    </h2>
                    <p className='inter-font'>We create websites that are easy to navigate and guide customers directly to their goals. With well-thought-out UX/UI, your site not only captures attention but also effectively boosts sales and conversions.
                    </p>
                    <div className='send-btn' onClick={handleBtnClick}>
                    <OrangeButton text='Contact us'/>
                    </div>
                </div>
                <div className='our-customers-right'>
                <div className='logos-grid'>
                    <LogoBrick
                        src={HivioLogo}
                        alt='Hivio Logo'

                    />
                    <LogoBrick
                        src={TcoLogo}
                        alt='Tco Logo'

                    />
                    <LogoBrick
                        src={SchLogo}
                        alt='Scharmach Logo'

                    />
                    <LogoBrick
                        src={SesvanLogo}
                        alt='Sesvan Logo'

                    />
                    <LogoBrick
                        src={HardRockLogo}
                        alt='Hard Rock Logo'

                    />
                    <LogoBrick
                        src={HavenLogo}
                        alt='Heven Logo'

                    />
                    <LogoBrick
                        src={HiltonLogo}
                        alt='Hilton Logo'

                    />
                    <LogoBrick
                        src={SheratonLogo}
                        alt='Sheraton Logo'

                    />
                    <LogoBrick
                        src={JaguarLogo}
                        alt='Jaguar Logo'
                    />

                </div>
                </div>
            </div>

        </div>
    )
}

export default OurCustomers